import React, { useState } from "react"
import { Button } from "../../ui/button"
import { Input } from "../../ui/input"
import { Textarea } from "../../ui/textarea"
import { Card, CardContent } from "../../ui/card"

export default function BillingForm({ task, onSubmit, loading, onClose }) {
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split("T")[0],
    hours: "",
    notes: "",
  })

  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))

    // Clear messages when form is changed
    if (success) setSuccess(false)
    if (error) setError(null)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!formData.hours || Number.parseFloat(formData.hours) <= 0) {
      setError("Please enter valid hours")
      return
    }

    try {
      await onSubmit(task.id, Number.parseFloat(formData.hours), formData.notes, formData.date)

      // Reset form
      setFormData({
        date: new Date().toISOString().split("T")[0],
        hours: "",
        notes: "",
      })

      setSuccess(true)
    } catch (error) {
      setError(error?.message || "The work log could not be saved. Please try again.")
    }
  }

  const handleCancel = () => {
    if (typeof onClose === "function") {
      onClose()
    }
  }

  return (
    <div className="group-work-log-form space-y-6">
      <div>
        <h3 className="text-lg font-medium">Work Logs</h3>
        <p className="text-sm text-gray-500">Total Hours: {task.billedHours || 0}</p>
      </div>

      {task.workLogs && task.workLogs.length > 0 ? (
        <div className="space-y-3 max-h-60 overflow-y-auto">
          {task.workLogs
            .sort((a, b) => new Date(b.date) - new Date(a.date))
            .map((log) => (
              <Card key={log.id} className="bg-gray-50">
                <CardContent className="p-3">
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="font-medium">{new Date(log.date).toLocaleDateString()}</p>
                      <p className="text-sm text-gray-500">{log.hours} hours</p>
                    </div>
                    {log.notes && <p className="text-sm italic">{log.notes}</p>}
                  </div>
                </CardContent>
              </Card>
            ))}
        </div>
      ) : (
        <p className="text-gray-500 text-center py-4">No work logs recorded</p>
      )}

      <div className="border-t pt-4">
        <h4 className="font-medium mb-3">Add Work Log</h4>

        <form onSubmit={handleSubmit} className="space-y-4">
          {error && <div className="p-3 bg-red-50 text-red-500 rounded-md">{error}</div>}

          {success && <div className="p-3 bg-green-50 text-green-500 rounded-md">Work log added successfully!</div>}

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Date</label>
              <Input name="date" type="date" value={formData.date} onChange={handleChange} required />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Hours</label>
              <Input
                name="hours"
                type="number"
                step="0.25"
                min="0.25"
                value={formData.hours}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Notes (Optional)</label>
            <Textarea name="notes" value={formData.notes} onChange={handleChange} rows={2} />
          </div>

          <div className="flex justify-end space-x-2">
            <Button type="button" variant="outline" onClick={handleCancel}>
              Cancel
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? "Adding..." : "Add Work Log"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}

